import { IconProps } from '.';

const TrophyIcon = ({
  color = 'var(--color-sage-300)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClasses}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.9141 5.41699H7.08073V15.8337C7.08073 22.5456 12.2002 28.0619 18.7474 28.6906V32.917H10.8307V35.417H29.1641V32.917H21.2474V28.6906C27.7946 28.0619 32.9141 22.5456 32.9141 15.8337V5.41699ZM9.58073 15.8337V7.91699H30.4141V15.8337C30.4141 21.5866 25.7504 26.2503 19.9974 26.2503C14.2444 26.2503 9.58073 21.5866 9.58073 15.8337ZM34.5807 15.0003V8.33366H37.0807V15.0003H34.5807ZM2.91406 8.33366V15.0003H5.41406V8.33366H2.91406Z"
        fill={color}
      />
    </svg>
  );
};

export default TrophyIcon;
